import React, { createContext, useContext, useState, ReactNode } from 'react';

interface IssueNavigationContextType {
  issueIds: number[];
  setIssueIds: (ids: number[]) => void;
  clearIssueIds: () => void;
}

const IssueNavigationContext = createContext<
  IssueNavigationContextType | undefined
>(undefined);

export function IssueNavigationProvider({ children }: { children: ReactNode }) {
  const [issueIds, setIssueIds] = useState<number[]>([]);

  const clearIssueIds = () => {
    setIssueIds([]);
  };

  return (
    <IssueNavigationContext.Provider
      value={{
        issueIds,
        setIssueIds,
        clearIssueIds,
      }}
    >
      {children}
    </IssueNavigationContext.Provider>
  );
}

export function useIssueNavigation() {
  const context = useContext(IssueNavigationContext);
  if (context === undefined) {
    throw new Error(
      'useIssueNavigation must be used within an IssueNavigationProvider'
    );
  }
  return context;
}
